/**
 * Owl Carousel Slider
 */



export default function HWY_Slider() {

	const selectors = {
		heroCarousel: ".hwy__hero .owl-carousel",
		mediaCarousel: ".hwy__carousel .owl-carousel",
		socialMediaCarousel: ".hwy__social_media .owl-carousel",
		productsCarousel: ".hwy__featured-wines .owl-carousel",
		tradeMediaCarousel: ".trade-page .images",
		eventsCarousel: ".events-page .owl-carousel",
		productImageCarousel: ".single-wine .owl-carousel",
		threeImagesCarousel: ".three-images .owl-carousel",
	};

	this.init = () => {
		createHeroSlide();
		createMediaSlide();
		createProductsSlide();
		createSocialMediaSlide();
		createTradeMediaSlide();
		createEventsSlide();
		createProductImageSlide();
		createThreeImagesCarousel();
	};

	const createHeroSlide = () => {
		if (jQuery(selectors.heroCarousel).length) {
			jQuery(selectors.heroCarousel).each(function () {
				const el = jQuery(this);
				el.owlCarousel({
					autoplay: true,
					autoplayHoverPause: true,
					autoplayTimeout: 7000,
					dotsEach: true,
					loop: true,
					nav: false,
					items: 1,
					smartSpeed: 700,
				});
			})
		}
	}

	const createMediaSlide = () => {
		if (jQuery(selectors.mediaCarousel).length) {
			jQuery(selectors.mediaCarousel).each(function () {
				const el = jQuery(this);
				el.owlCarousel({
					// autoplay: true,
					// autoplayHoverPause: true,
					// autoplayTimeout: 7000,
					center: true,
					dotsEach: false,
					loop: true,
					nav: true,
					navText: [
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Next.svg" alt="Go to the next item">',
					],
					items: 1,
					responsive : {
						0: {
							margin: 0,
							stagePadding: 0,
						},
						769: {
							margin: 75,
							stagePadding: 150,
							// autoWidth: true,
						},
						1024: {
							margin: 95,
							stagePadding: 190,
							// autoWidth: true,
						},
					},
					smartSpeed: 700,
				});
			})
		}
	}

	const createThreeImagesCarousel = () => {
		if (jQuery(selectors.threeImagesCarousel).length) {
			jQuery(selectors.threeImagesCarousel).each(function () {
				const el = jQuery(this);
				el.owlCarousel({
					autoplay: true,
					autoplayTimeout: 7000,
					center: true,
					dotsEach: false,
					loop: true,
					nav: true,
					navText: [
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Next.svg" alt="Go to the next item">',
					],
					items: 1,
					smartSpeed: 700,
				});
			})
		}
	}

	const createSocialMediaSlide = () => {
		if (jQuery(selectors.socialMediaCarousel).length) {
			jQuery(selectors.socialMediaCarousel).each(function () {
				const el = jQuery(this);
				el.owlCarousel({
					autoplay: true,
					autoplayHoverPause: true,
					autoplayTimeout: 7000,
					// center: true,
					dotsEach: false,
					loop: true,
					nav: true,
					navText: [
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Next.svg" alt="Go to the next item">',
					],
					items: 2,
					responsive : {
						0: {
							margin: 10,
							stagePadding: 0,
						},
						769: {
							margin: 15,
							stagePadding: 150,
						},
						1024: {
							margin: 20,
							stagePadding: 220,
						},
					},
					smartSpeed: 700,
				});
			})
		}
	}

	const createTradeMediaSlide = () => {
		if (jQuery(selectors.tradeMediaCarousel).length) {
			jQuery(selectors.tradeMediaCarousel).each(function () {
				const el = jQuery(this);
				el.owlCarousel({
					autoplay: true,
					autoplayHoverPause: true,
					autoplayTimeout: 7000,
					// center: true,
					dotsEach: false,
					loop: true,
					nav: true,
					navText: [
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Next.svg" alt="Go to the next item">',
					],
					items: 2,
					responsive : {
						0: {
							margin: 10,
							stagePadding: 0,
						},
						769: {
							margin: 15,
							stagePadding: 150,
						},
						1024: {
							margin: 20,
							stagePadding: 220,
						},
					},
					smartSpeed: 700,
				});
			})
		}
	}

	const createProductsSlide = () => {
		if (jQuery(selectors.productsCarousel).length) {
			jQuery(selectors.productsCarousel).each(function () {
				const el = jQuery(this);
				el.owlCarousel({
					autoplay: true,
					autoplayHoverPause: true,
					autoplayTimeout: 7000,
					// center: true,
					dotsEach: false,
					loop: true,
					nav: true,
					navText: [
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
						'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Next.svg" alt="Go to the next item">',
					],
					responsive : {
						0: {
							items: 1,
							margin: 10,
							stagePadding: 0,
						},
						769: {
							items: 2,
							margin: 15,
							stagePadding: 150,
						},
						1024: {
							items: 2,
							margin: 20,
							stagePadding: 220,
						},
					},
					smartSpeed: 700,
				});
			})
		}
	}

	const createEventsSlide = () => {
		if (jQuery(selectors.eventsCarousel).length) {
			jQuery(selectors.eventsCarousel).owlCarousel({
				autoplay: true,
				autoplayHoverPause: true,
				autoplayTimeout: 7000,
				// center: true,
				dotsEach: false,
				loop: true,
				nav: true,
				navText: [
					'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
					'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Next.svg" alt="Go to the next item">',
				],
				responsive : {
					0: {
						items: 1,
						margin: 10,
						stagePadding: 0,
					},
					769: {
						items: 2,
						margin: 15,
						stagePadding: 150,
					},
					1024: {
						items: 2,
						margin: 20,
						stagePadding: 220,
					},
				},
				smartSpeed: 700,
			});
		}
	}

	const createProductImageSlide = () => {
		if (jQuery(selectors.productImageCarousel).length) {
			jQuery(selectors.productImageCarousel).owlCarousel({
				autoplay: true,
				autoplayHoverPause: true,
				autoplayTimeout: 7000,
				// center: true,
				dotsEach: false,
				loop: true,
				nav: true,
				navText: [
					'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
					'<img src="/wp-content/themes/WineDirect/assets/images/SVG/Next.svg" alt="Go to the next item">',
				],
				items: 1,
				smartSpeed: 700,
			});
		}
	}

	const createCarousels = () => {
		if (jQuery(selectors.carousel).length) {
			jQuery(selectors.carousel).each(function () {
				const el = jQuery(this);
				const autoScroll = el.data("scroll") ? el.data("scroll") : false;
				const numbers = el.data("numbers") ? el.data("numbers") : 1;
				const margin = el.data("margin") ? el.data("margin") : 0;

				el.owlCarousel({
					autoplay: autoScroll,
					autoplayHoverPause: true,
					autoplayTimeout: 7000,
					dotsEach: true,
					loop: true,
					margin: margin,
					nav: true,
					navText: [
						'<img src="/wp-content/themes/WineDirect/assets/images/prev.svg" alt="Go to the previous item">',
						'<img src="/wp-content/themes/WineDirect/assets/images/next.svg" alt="Go to the next item">',
					],
					responsive: {
						0: {
							items: 1
						},
						768: {
							items: 2
						},
						1024: {
							items: numbers
						}
					},
					smartSpeed: 700,
				});
			})
		}
	}
}
